import React from "react"
import * as Icon from "react-feather"
import groupTitles from "../assets/data/locales/groupTitles";

const activeProds = localStorage.getItem('activeProds')
const deletedProds = localStorage.getItem('deletedProds')
const claims = localStorage.getItem('claims')
const tickets = localStorage.getItem('tickets')
const messages = localStorage.getItem('messageCount')

let lang = localStorage.getItem("uiLang") ? localStorage.getItem("uiLang") : "en";
let companyId = localStorage.getItem("companyId");
let mpProductsSearch = localStorage.getItem('mpProductsearch') ? localStorage.getItem('mpProductsearch') : null

const isCompanyValid = (companyId) => {
  const validCompanyIds = ['50', '364', '6250'];
  const validQACompanyIds = ['790', '3159', '3139', '3123', '3130', '3131', '3101', '3132', '3133', '3134', '41', '3235', '3342', '3182'];
  const expectedApiUrl = 'https://api.hepsiglobal.com/api/admin';
  const expectedQAApiUrl = 'https://api-qa.hepsiglobal.com/api/admin';

  const isValidCompanyId = validCompanyIds.includes(companyId);
  const isQAValidCompanyId = validQACompanyIds.includes(companyId);

  const isApiUrlValid = process.env.REACT_APP_API_ADMIN_URL === expectedApiUrl;
  const isQAApiUrlValid = process.env.REACT_APP_API_ADMIN_URL === expectedQAApiUrl;

  return (isApiUrlValid && isValidCompanyId) || (isQAApiUrlValid && isQAValidCompanyId);
};

const extractAdminLoginPath = (url) => {
  const parts = url.split('/');
  const index = parts.indexOf('admin');
  if (index !== -1 && index + 1 < parts.length) {
    return parts.slice(index, index + 2).join('/');
  }
  return null;
}

if((extractAdminLoginPath(window.location.href) === 'admin/login') && (localStorage.getItem('userRole') === 'user')) {
  localStorage.clear()
}

const navigationConfig = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["noOriginCountry", "user",/* "admin",*/ "adminAsUser"],
    navLink: "/dashboard"
  },
  {
    id:"data",
    type: "groupHeader",
    groupTitle: groupTitles["data"][lang],
    permissions: ["user", "adminAsUser"]
  },
  {
    id: "category_management",
    title: "Categories",
    type: "collapse",
    icon: <Icon.Layers size={20} />,
    permissions: ["user", "adminAsUser"],
    children: [
      {
        id: "category_list",
        title: "Category List",
        type: "item",
        icon: <Icon.Layers size={20} />,
        permissions: ["user",  "adminAsUser"],
        navLink: "/categories"
      },
      {
        id: "restricted_categories",
        title: "Restricted Categories",
        type: "item",
        icon: <Icon.Slash size={20} />,
        permissions: ["user",  "adminAsUser"],
        navLink: "/categories/restricted-categories"
      }
    ]
  },
  {
    id: "attribute_management",
    title: "Attributes",
    type: "item",
    icon: <Icon.Tag size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/old-attributes"
  },
  {
    id: "product_management",
    title: "Products",
    type: "collapse",
    icon: <Icon.Codepen size={20} />,
    permissions: ["user", "adminAsUser"],
    children: [
      {
        id: "quick_edit",
        title: "All Products",
        type: "item",
        badge: "success",
        badgeText: activeProds,
        // icon: <Icon.Zap size={20} />,
        permissions: ["user", "adminAsUser"],
        navLink: "/products/quick-edit"
      },
      {
        id: "deleted_products",
        title: "Deleted",
        type: "item",
        badge: "danger",
        badgeText: deletedProds,
        // icon: <Icon.Codepen size={20} />,
        permissions: ["user", "adminAsUser"],
        navLink: "/deleted-products"
      },
      {
        id: "mp_products_variant",
        title: "Marketplace Products",
        type: "item",
        permissions: ["user", "adminAsUser"],
        navLink: "/products/mp-products"
      },
      {
        id: "product_validation",
        title: "Product Validation",
        type: "item",
        permissions: isCompanyValid(companyId) ? ["user", "adminAsUser"] : [],
        navLink: "/products/product-validation"
      },
    ]
  },
  {
    id: "brand_management",
    title: "Brands",
    type: "item",
    icon: <Icon.Star size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/brands"
  },
  {
    id:"dataImport",
    type: "groupHeader",
    groupTitle: groupTitles["dataImport"][lang],
    permissions: ["user", "adminAsUser"]
  },
  {
    id: "excel_import",
    title: "Product/Variant Import",
    type: "item",
    icon: <Icon.UploadCloud size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/importer/excel-product-variant"
  },
  {
    id: "excel_stock_price_import",
    title: "Stock/Price Import",
    type: "item",
    icon: <Icon.UploadCloud size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/importer/excel-stock-price"
  },
  {
    id: "ff_import",
    title: "Fulfillment Day Import",
    type: "item",
    icon: <Icon.UploadCloud size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/importer/fulfillment-day-import"
  },
  {
    id:"operation",
    type: "groupHeader",
    groupTitle: groupTitles["operation"][lang],
    permissions: ["user", "adminAsUser"]
  },
  {
    id: "marketplace_sales",
    title: "Marketplace Sales",
    type: "item",
    icon: <Icon.List size={20} />,
    permissions: ["adminAsUser"],
    navLink: "/marketplace-sales"
  },
  {
    id: "orders",
    title: "Orders",
    type: "collapse",
    icon: <Icon.ShoppingBag size={20} />,
    permissions: ["user", "adminAsUser"],
    children: [
      {
        id: "all_orders",
        title: "All",
        type: "item",
        // icon: <Icon.List size={20} />,
        permissions: ["user", "adminAsUser"],
        navLink: "/orders"
      },
      {
        id: "refunds",
        title: "Refunded",
        type: "item",
        // icon: <Icon.List size={20} />,
        permissions: ["user", "adminAsUser"],
        navLink: "/orders/refunded"
      },
      {
        id: "cancellations",
        title: "Cancelled",
        type: "item",
        // icon: <Icon.List size={20} />,
        permissions: ["user", "adminAsUser"],
        navLink: "/orders/cancelled"
      }
    ]
  },
  {
    id: "packages",
    title: "Packages",
    type: "item",
    icon: <Icon.Package size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/packages",
  },
  {
    id: "claims_tickets",
    title: "Claims & Questions",
    type: "collapse",
    icon: <Icon.HelpCircle size={20} />,
    permissions: ["user", "adminAsUser"],
    children: [
      {
        id: "claims",
        title: "Claims",
        type: "item",
        badge: "warning",
        badgeText: claims,
        icon: <Icon.HelpCircle size={20} />,
        permissions: ["adminAsUser", "user"],
        navLink: "/claims"
      },
      {
        id: "questions",
        title: "Questions",
        type: "item",
        badge: "warning",
        badgeText: tickets,
        icon: <Icon.List size={20} />,
        permissions: ["adminAsUser", "user"],
        navLink: "/questions"
      },
      {
        id: "messages",
        title: "Messages",
        type: "item",
        badge: "warning",
        badgeText: messages,
        icon: <Icon.Mail size={20} />,
        permissions: ["adminAsUser", "user"],
        navLink: "/messages"
      }
    ]
  },
  {
    id:"reports",
    type: "groupHeader",
    groupTitle: groupTitles["reports"][lang],
    permissions: ["user", "adminAsUser"]
  },
  {
    id: "marketplace_logs",
    title: "Marketplace Logs",
    type: "item",
    icon: <Icon.Layers size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/reports/marketplaces"
  },
  {
    id: "transactions",
    title: "Transactions",
    type: "item",
    icon: <Icon.List size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/reports/transactions"
  },
  // {
  //   id: "reconciliation",
  //   title: "Reconciliation",
  //   type: "item",
  //   icon: <Icon.Book size={20} />,
  //   permissions: ["user"],
  //   navLink: "/reconciliation"
  // },
  {
    id: "reconciliation_payments",
    title: "Reconciliation & Payments",
    type: "collapse",
    icon: <Icon.Book size={20} />,
    permissions: ["user"],
    children: [
      {
        id: "reconciliation",
        title: "Reconciliation",
        type: "item",
        icon: <Icon.BookOpen size={20} />,
        permissions: ["user", "adminAsUser"],
        navLink: "/reconciliation-admin"
      },
      {
        id: "payments",
        title: "Payments",
        type: "item",
        icon: <Icon.BookOpen size={20} />,
        permissions: ["adminAsUser"],
        navLink: "/payments"
      },
    ]
  },
  {
    id:"settings",
    type: "groupHeader",
    groupTitle: groupTitles["settings"][lang],
    permissions: ["user", "adminAsUser"]
  },
  {
    id: "company_info",
    title: "Company Info",
    type: "item",
    icon: <Icon.Clipboard size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/company-info"
  },
  {
    id: "api_settings",
    title: "API Settings",
    type: "item",
    icon: <Icon.Key size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/api-settings"
  },
  {
    id: "logistics",
    title: "Logistics",
    type: "item",
    icon: <Icon.Calendar size={20} />,
    permissions: ["user", "adminAsUser"],
    navLink: "/logistics"
  },
  {
    id:"faqGroup",
    type: "groupHeader",
    groupTitle: groupTitles["help"][lang],
    permissions: ["user", "adminAsUser"]
  },
  {
    id: "onboarding",
    title: "Onboarding",
    type: "collapse",
    icon: <Icon.HelpCircle size={20} />,
    permissions: ["user", "adminAsUser"],
    children: [
      {
        id: "faq",
        title: "FAQ",
        type: "item",
        icon: <Icon.HelpCircle size={20} />,
        permissions: ["user", "adminAsUser"],
        navLink: "/faq"
      },
      {
        id: "tutorials",
        title: "Tutorials",
        type: "item",
        icon: <Icon.HelpCircle size={20} />,
        permissions: ["user", "adminAsUser"],
        navLink: "/tutorials"
      },
    ]
  },
  // {
  //   id: "dashboardCache",
  //   title: "Dashboard Cache",
  //   type: "item",
  //   icon: <Icon.Trash size={20} />,
  //   permissions: ["admin"],
  //   navLink: "/admin/dashboard-cache"
  // },
  {
    id:"loginGroup",
    type: "groupHeader",
    groupTitle: "",
    permissions: ["admin"],
  },
  {
    id: "adminCompanies",
    title: "Companies",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin"],
    navLink: "/admin/companies"
  },
  {
    id: "adminProductValidation",
    title: "Product Validation",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin"],
    navLink: "/admin/product-validation"
  },
  {
    id: "adminProductTools",
    title: "Product Tools",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin"],
    navLink: "/admin/product-tools"
  },
  {
    id: "adminCategoryTree",
    title: "Seller Portal Categories",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin"],
    navLink: "/admin/category-tree"
  },
  {
    id: "adminAttributes",
    title: "Seller Portal Attributes ",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin"],
    navLink: "/admin/attributes"
  },
  {
    id: "adminCategoryCross",
    title: "Category Cross",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin"],
    navLink: "/admin/category-cross"
  },
  {
    id: "adminAttributeCrossing",
    title: "Attribute Cross",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin"],
    navLink: "/admin/attribute-crossing/"
  },
  {
    id: "adminMpProductsVariants",
    title: "Marketplace Products",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin"],
    navLink: "/admin/mp-products/"
  },
  {
    id: "adminMpRateCap",
    title: "Marketplace Rate Cap",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin"],
    navLink: "/admin/mp-rate-cap/"
  },
  {
    id: "adminPriceStockSync",
    title: "HB Price/Stock Sync",
    type: "item",
    icon: <Icon.RefreshCcw size={20} />,
    permissions: ["admin"],
    navLink: "/admin/price-stock-sync"
  },
  {
    id: "adminCommissions",
    title: "Commissions",
    type: "item",
    icon: <Icon.DollarSign size={20} />,
    permissions: ["admin"],
    navLink: "/admin/commissions"
  },
  {
    id: "adminCampaigns",
    title: "Campaigns",
    type: "item",
    icon: <Icon.Percent size={20} />,
    permissions: ["admin"],
    navLink: "/admin/campaigns"
  },
  {
    id: "adminOrderClaimTools",
    title: "Order & Claim Tools",
    type: "item",
    icon: <Icon.Tool size={20} />,
    permissions: ["admin"],
    navLink: "/admin/order-claim-tools/index"
  },
  {
    id: "adminCancelRefundApprove",
    title: "Cancel/Refund Approve",
    type: "item",
    icon: <Icon.Monitor size={20} />,
    permissions: ["admin"],
    navLink: "/admin/cancel-refund-approve"
  },
  {
    id: "adminLeadTimeTools",
    title: "Lead Time Tools",
    type: "item",
    icon: <Icon.Tool size={20} />,
    permissions: ["admin"],
    navLink: "/admin/lead-time-tools"
  },
  {
    id: "adminCategoryTools",
    title: "Category Tools",
    type: "item",
    icon: <Icon.Tool size={20} />,
    permissions: ["admin"],
    navLink: "/admin/categories/categories"
  },
  {
    id: "adminCompanyTools",
    title: "Company Tools",
    type: "item",
    icon: <Icon.Tool size={20} />,
    permissions: ["admin"],
    navLink: "/admin/company-tools"
  },
  {
    id: "adminBrandTools",
    title: "Brand Tools",
    type: "item",
    icon: <Icon.Tool size={20} />,
    permissions: ["admin"],
    navLink: "/admin/brand-tools"
  },
  {
    id: "adminStockTools",
    title: "Stock Tools",
    type: "item",
    icon: <Icon.Tool size={20} />,
    permissions: ["admin"],
    navLink: "/admin/stock-tools"
  },
  {
    id: "adminHardDelete",
    title: "Delete",
    type: "item",
    icon: <Icon.Trash2 size={20} />,
    permissions: ["admin"],
    navLink: "/admin/hard-delete"
  },
  {
    id: "adminTagManagement",
    title: "Tag Management",
    type: "item",
    icon: <Icon.Tag size={20} />,
    permissions: ["admin"],
    navLink: "/admin/tag-management"
  },
  {
    id: "adminLogistics",
    title: "Logistics",
    type: "item",
    icon: <Icon.Package size={20} />,
    permissions: ["admin"],
    navLink: "/admin/logistics/logistics"
  },
  {
    id: "adminReports",
    title: "Reports",
    type: "item",
    icon: <Icon.Book size={20} />,
    permissions: ["admin"],
    navLink: "/admin/reports/index"
  },
  // Admin Currency
  {
    id: "adminCurrency",
    title: "Currency Tools",
    type: "item",
    icon: <Icon.DollarSign size={20} />,
    permissions: [],
    navLink: "/currency-tools-admin/index"
  },
  // {
  //   id: "profitCalculator",
  //   title: "Profit Calculator",
  //   type: "item",
  //   icon: <Icon.DollarSign size={20} />,
  //   permissions: ["admin"],
  //   navLink: "/profit-calculator"
  // },
  {
    id: "adminPanel",
    title: "Admin Panel",
    type: "item",
    icon: <Icon.LogIn size={20} />,
    permissions: ["adminAsUser"],
    navLink: "/admin/back"
  },
  {
    id: "adminMpProducts",
    title: "Return Admin Mp Products",
    type: "item",
    icon: <Icon.LogIn size={20} />,
    permissions: ["adminAsUser"],
    navLink: "/admin/back?target=mp-products",
    isShow: !!mpProductsSearch
  },
]

export default navigationConfig
